import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-title',
  templateUrl: './report-title.component.html',
  styleUrl: './report-title.component.scss',
})
export class ReportTitleComponent {
  @Input() textCenter: boolean;
  @Input() textRight: boolean;
}
